<template>
  <div ref="layout" class="page-form">
    <h3 class="title">产品信息</h3>

    <div class="tools" style="padding-left: 48px">
      <form-button name="返回" @click="$router.go(-1)" />
    </div>

    <div v-if="productData" class="container">
      <collapse-query2 title="基本信息">
        <base-info ref="base" :prod="productData" />
      </collapse-query2>

      <collapse-query2 title="计划属性">
        <plan-attr ref="plan" :prod="productData" />
      </collapse-query2>

      <collapse-query2 title="配额信息">
        <quota-info ref="quota" :prod="productData" />
      </collapse-query2>

      <collapse-query2 title="附加信息">
        <attach-info ref="attach" :prod="productData" />
      </collapse-query2>
    </div>
  </div>
</template>

<script>
import BaseInfo from './BaseInfoCheck.vue'
import PlanAttr from './PlanAttrCheck.vue'
import QuotaInfo from './QuotaInfoCheck.vue'
import AttachInfo from './AttachInfoCheck.vue'

import { apiProductDetail } from '@/api/sap/client-sap'
export default {
  components: {
    AttachInfo,
    QuotaInfo,
    PlanAttr,
    BaseInfo
  },
  data() {
    return {
      productData: null
    }
  },
  created() {
    this.getInfo(this.$route.query.id)
  },
  methods: {
    async getInfo(product_id) {
      const { data } = await apiProductDetail({ product_id })
      this.productData = {
        ...data.head,
        history: data.history,
        yxdy: data.yxdy
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container{
  padding: 0 48px;
}
</style>



// WEBPACK FOOTER //
// src/views/product-manage/components/productCheck.vue